export default "__VITE_ASSET__CLz2w1D9__"